import {Button, Grid} from "@mui/material";

// coverFile is stored as "X" (no files), a single URL, or a JSON array of URLs.
export function parseFileLinks(rawCover) {
    if (!rawCover || rawCover === "X") {
        return [];
    }
    try {
        const parsed = JSON.parse(rawCover);
        if (Array.isArray(parsed)) {
            return parsed.filter((link) => link);
        }
        if (typeof parsed === "string") {
            return [parsed];
        }
    } catch (e) {
        // Not JSON, so it is a plain URL.
    }
    return [rawCover];
}

// Uploaded keys are a UUID followed by the original file name, e.g. "1b9d...-...-6bcdMyCV.pdf".
const uuidPrefix = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export function fileNameFromLink(link, index) {
    try {
        const name = decodeURIComponent(new URL(link, window.location.origin).pathname.split("/").pop());
        return name.replace(uuidPrefix, "") || `File ${index + 1}`;
    } catch (e) {
        return `File ${index + 1}`;
    }
}

// One real link per file. Opening several files from a single click with window.open is blocked by browsers.
const FileLinks = ({ links, className }) => (
    <Grid container direction="column" rowSpacing={1}>
        {links.map((link, index) => (
            <Grid item key={link + index}>
                <Button className={className} component="a" href={link} target="_blank" rel="noopener noreferrer"
                        sx={{textTransform: "none", overflowWrap: "anywhere"}}>
                    {fileNameFromLink(link, index)}
                </Button>
            </Grid>
        ))}
    </Grid>
);

export default FileLinks;
